import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef, useState } from "react";
import { useFocusVisible, useFocus } from "react-aria";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toStateClass } from "../../utils/toStateClass.js";
import { Label } from "../Typography/Label.js";
const TabButton = memo(
  forwardRef(({
    isSelected,
    isDisabled = false,
    children,
    ...rest
  }, ref) => {
    const prefix = `${useClassNamePrefix()}tab-button`;
    const [isFocused, setIsFocused] = useState(false);
    const { isFocusVisible } = useFocusVisible();
    const classList = classNames(
      `${prefix}`,
      toStateClass("selected", !isDisabled && isSelected),
      toStateClass("focused", !isDisabled && isFocused && isFocusVisible),
      toStateClass("disabled", isDisabled)
    );
    const { focusProps } = useFocus({
      isDisabled,
      onFocusChange: setIsFocused
    });
    return /* @__PURE__ */ jsx(
      "button",
      {
        ...focusProps,
        ...rest,
        className: classList,
        ref,
        disabled: isDisabled,
        children: /* @__PURE__ */ jsx("span", { className: `${prefix}-label`, children: typeof children === "string" ? /* @__PURE__ */ jsx(
          Label,
          {
            isActive: isSelected,
            isDisabled,
            isFocused: isFocused && isFocusVisible,
            children
          }
        ) : children })
      }
    );
  })
);
TabButton.displayName = "TabButton";
export {
  TabButton
};
//# sourceMappingURL=TabButton.js.map
